<template>
    <router-view></router-view>
</template>

<script>
    export default {
        name: "Register"
    }
</script>

<style scoped>

</style>


